import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import EnhancedTable from "@meetyoo/components/src/components/Table/EnhancedTable";
import ErrorModal from "@meetyoo/components/src/components/Modal/ErrorModal";

import BillingDocumentSendingFilter from "../BillingDocumentSendingFilter";
import BillingDocumentSendingTableRow from "../BillingDocumentSendingTableRow";
import BillingDocumentSendingEvent from "../BillingDocumentSendingEvent";

const headRows = [
  { id: "id", numeric: false, disablePadding: true, label: "Document Id" },
];

export const BillingDocumentSendingComponent = ({
  errorMessage,
  translate,
  documentNumbers,
  requestInProgress,
}) => {
  const [openErrorModal, setOpenErrorModal] = useState(false);

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const prepareData = [].concat(
    documentNumbers.map((id) => {
      return { id: String(id) };
    })
  );

  return [
    <EnhancedTable
      key="billing-sending"
      title={translate.billingSending}
      rows={prepareData}
      headRows={headRows}
      tableRowComponent={BillingDocumentSendingTableRow}
      inProgress={requestInProgress}
      filterChildren={<BillingDocumentSendingFilter />}
    />,
    <BillingDocumentSendingEvent key="billing-sending-event" />,
    <ErrorModal
      key="error"
      handleCloseErrorModal={handleCloseErrorModal}
      openErrorModal={openErrorModal}
      errorMessage={errorMessage}
    />,
  ];
};

BillingDocumentSendingComponent.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  documentNumbers: PropTypes.array.isRequired,
  requestInProgress: PropTypes.bool.isRequired,
  translate: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  documentNumbers: state.billing.documentNumbers,
  errorMessage: state.billing.documentErrorStatus,
  requestInProgress: state.billing.requestBillingInProgress,
  translate: state.ui.translate,
});

const BillingDocumentSending = connect(mapStateToProps)(
  BillingDocumentSendingComponent
);

export default BillingDocumentSending;
